import image from "../images/Railway-1.jpg";
import { useState } from "react";

const Railway = () => {
    const [block, setblock] = useState(false);

    function FullView(ImgLink){
        document.getElementById("FullImage1").src = ImgLink;
        setblock(true);
    }

    function CloseFullView(){
        setblock(false);
    }

    return ( 
        <>
            <div className="main-container">
                    <h2>Railway</h2>
                    <div className="components-section">
                        <div className="comp">
                            <div className="component">Roiling Stock Components</div>
                            <div className="list">
                                <ul>
                                    <li>Contactors</li>
                                    <li>Heaters repairs</li>
                                    <li>Resistors(5M2A,10M) </li>
                                    <li>Compressors </li>
                                    <li>Switches/Overloads </li>
                                    <li>Shaft Encoders</li>
                                </ul>
                            </div>
                        </div>
                        <div className="comp">
                            <div className="component second">Supply and Installations</div>
                            <div className="list">
                                <ul>
                                    <li>Marley Flooring</li>
                                    <li>Seats</li>
                                </ul>
                            </div>
                        </div>
                        <div className="comp">
                            <div className="component">Maintenance and Support</div>
                            <div className="list">
                                <ul>
                                    <li>Call outs</li>
                                    <li>Root cause analysis</li>
                                    <li>Preventative Maintenance</li>
                                    <li>Bogie Mini Profiling</li>
                                </ul>
                            </div>
                        </div>
                        
                    </div>
                    
                    <h3>Image Gallary </h3>
                    <h5>(Click image for fullscreen)</h5>
                    <div className="images">
                        <img src={image} onClick={() => FullView(image)} alt=""/>
                    </div>
                    <div className="fullImageView" style={{display: block? "block" : "none"}}>
                        <img id="FullImage1" alt=""  />
                        <i className="fa fa-times CloseButton" onClick={() => CloseFullView()}></i>
                    </div>
                </div>
                <div className="end-section">
                </div>
            </>
     );
}
 
export default Railway;